import { render, staticRenderFns } from "./WdcCampaignChannelDesignRecord.vue?vue&type=template&id=29a452bc&"
import script from "./WdcCampaignChannelDesignRecord.vue?vue&type=script&lang=js&"
export * from "./WdcCampaignChannelDesignRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports